export enum TopBarFullThemes {
  white = 'white',
  warning = 'warning',
  midnight = 'midnight',
}

export enum TopBarFullImagePositions {
  high = 'high',
  low = 'low',
}

export enum TopBarFullCtaColors {
  alt = 'alt',
  upgrade = 'upgrade',
}

export enum TopBarFullImageSizes {
  small = 'small',
  large = 'large',
}

export enum TopBarFullUseCaseEnums {
  InitiatedDrafted = 'initiated_drafted',
  TestedActivated = 'tested_activated',
  Deployed = 'deployed',
}

export enum AudienceUpsellEnums {
  NotGuac = 'not_guac',
}
